export const findAndUpdateModalVehicleData = ({ vehicleModalData, caseId, updatedRepoHitList }) => {
  if (!vehicleModalData) return null;
  const data = updatedRepoHitList.find((item) => item.caseId === caseId);
  return data;
};

export const updateSpottedNoteOnCase = ({ currentRepoHitList, spottedNote, caseId }) => {
  if (!currentRepoHitList) return currentRepoHitList;

  const matchedCase = currentRepoHitList.find((c) => c.caseId === caseId);
  if (!matchedCase) return currentRepoHitList;

  const mappedCases = currentRepoHitList.map((c) => {
    if (c.caseId !== caseId) return c;

    return {
      ...c,
      spottedNotes: [spottedNote, ...c.spottedNotes],
      _count: {
        spottedNotes: c._count.spottedNotes + 1,
      },
    };
  });

  return mappedCases;
};

export const editSpottedNoteOnCase = ({ currentRepoHitList, spottedNote, currentModalSpottedNotes, caseId }) => {
  //spottedNote props should receive the new note

  ////////////////////// currentRepoHitList
  //check the currentRepoHitList was sent

  let mappedCasesRHL = [];

  //check the case exists in the current list and saves time if not
  const matchedCase = currentRepoHitList.find((c) => c.caseId === caseId);

  if (currentRepoHitList && matchedCase) {
    mappedCasesRHL = currentRepoHitList.map((c) => {
      if (c.caseId !== caseId) return c;

      //Map throught the notes and edit the one with the same id
      const editedNotes = c.spottedNotes.map((note) => {
        if (note.id !== spottedNote.id) return note;

        //Edit the note and add it to the array within the case
        return {
          ...note,
          text: spottedNote.text,
          editedByUser: spottedNote.editedByUser,
          createdAt: spottedNote.createdAt,
        };
      });

      return {
        ...c,
        spottedNotes: [...editedNotes],
        _count: {
          spottedNotes: c._count.spottedNotes,
        },
      };
    });
  }

  const updatedModalSpottedNotes = currentModalSpottedNotes.map((note) => {
    if (note.id !== spottedNote.id) return note;

    return {
      ...note,
      text: spottedNote.text,
      editedByUser: spottedNote.editedByUser,
      createdAt: spottedNote.createdAt,
    };
  });

  //Return the updated list
  return {
    updatedRepoHitList: mappedCasesRHL,
    updatedModalSpottedNotes,
  };
};

export const deleteSpottedNoteOnCase = ({ currentRepoHitList, currentModalSpottedNotes, spottedNote, caseId }) => {
  //spottedNote props should receive the new note
  ////////////////////// currentRepoHitList

  let mappedCasesRHL = [];
  //check the case exists in the current list and saves time if not
  const matchedCase = currentRepoHitList.find((c) => c.caseId === caseId);

  if (currentRepoHitList && matchedCase) {
    mappedCasesRHL = currentRepoHitList.map((c) => {
      if (c.caseId !== caseId) return c;

      //Map throught the notes and edit the one with the same id
      const editedNotes = c.spottedNotes.filter(
        (note) => note.id !== spottedNote.id,
        //Do not return the note being deleted
      );
      return {
        ...c,
        spottedNotes: [...editedNotes],
        _count: {
          spottedNotes: c._count.spottedNotes - 1,
        },
      };
    });
  }

  const updatedModalSpottedNotes = currentModalSpottedNotes.filter((note) => {
    return note.id !== spottedNote.id;
  });

  //Return the updated list
  return {
    updatedRepoHitList: mappedCasesRHL,
    updatedModalSpottedNotes,
  };
};

export const updateAssigneesOnCase = async ({ currentRepoHitList, caseId, usersAssigned }) => {
  if (!currentRepoHitList) return currentRepoHitList;

  const matchedCase = currentRepoHitList.find((c) => c.caseId === caseId);
  if (!matchedCase) return currentRepoHitList;

  const finalCase = { ...matchedCase, usersAssigned };

  return currentRepoHitList.map((c) => {
    if (c.caseId !== caseId) return c;
    return finalCase;
  });
};

export const updateModalAssignees = async (currentModalData, usersAssigned) => {
  if (!currentModalData) return currentModalData;

  const modalData = { ...currentModalData, usersAssigned };

  return modalData;
};

export const groupCountsByRHL = async (rhl, currentUser) => {
  //Get orderType from params
  const urlSearchParams = new URLSearchParams(window.location.search);
  const orderType = urlSearchParams.get('orderType');

  //Count the current orders for that param
  let counter = 0;

  for (const { usersAssigned } of rhl) {
    const isUserAssigned = usersAssigned.find((assignation) => {
      return assignation.user.id === currentUser.id;
    });

    if (isUserAssigned) {
      counter += 1;
    }
  }

  return {
    counter,
    orderType,
  };
};

export function normalizeDataForMap(data) {
  return data.map((item) => {
    return {
      ...item,
      user: item.spotter,
    };
  });
}
